import React, { Component } from 'react';
import { Button, message } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import ExportUtil from '../../../common/ExportUtil';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import TableC from '../../basicElement/TableC';
import moment from 'moment';
import ExportSelectRangeModal from './ExportSelectRangeModal';

const yearFormat = 'YYYY';
let year = moment().format(yearFormat);

class Filter extends Component {
    handleChange = (params, key) => {
        if (key === 'begin') {
            year = moment(params.begin).format(yearFormat);
        } else {
            year = moment(params.end).format(yearFormat);
        }
        params.begin = `${year}-01`;
        params.end = `${year}-12`;
        this.props.onChange(params, key);
    }

    render() {
        const { businessList, ...rest } = this.props;
        const businessOption = businessList.map(i => ({ value: i.typeConfigureId, label: i.typeValue }));
        const filters = [{
            name: '统计时间段',
            key: 'begin',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '至',
            key: 'end',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '领域leader',
            key: 'leaderUser',
            type: 'searchRetrieve',
            typeProperty: {
                keyword: 'keyword',
                style: {width: 140},
                placeholder: '输入姓名/工号检索',
                params: {limit: 20},
                url: API_URL.user.queryLeaderList,
                config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' }
            }
        }, {
            name: '业务线',
            key: 'lineOfBusiness',
            type: 'select',
            typeProperty: {
                list: businessOption,
            }
        }];
        return (
            <FilterBasic filters={filters} {...rest} onChange={this.handleChange} />
        )
    }
}

class RandomInGroupVisit extends Component {
    state = {
        data: [],
        businessList: [],
        loading: false,
        sortParams: {},
        searchParams: {
            begin: `${year}-01`,
            end: `${year}-12`,
        },
        curParams: {
            begin: `${year}-01`,
            end: `${year}-12`,
        },
        pagination: {
            pageSize: 10,
            current: 1,
        },
    }

    componentDidMount() {
        this.loadData();
        this.queryWithLevelByParams();
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => this.setState({ businessList: res.typeConfigureList || [] }));
    }

    loadData = () => {
        const { sortParams, curParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryInvUserVisitAndWorkType,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...curParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: {
                ...searchParams,
            },
        }, () => {
            this.loadData();
        });
    }

    showExportModal = () => {
        this.exportSelectRangeRef.show();
    }

    export = (exportParams) => {
        const { sortParams, curParams } = this.state;
        const url = API_URL.dashboard.exportInvUserVisitAndWorkType;
        this.addToDownloadSite({ ...sortParams, ...curParams, ...exportParams }, url, 'Report_Random_Work_Type');
    }

    addToDownloadSite = (searchArray, url, type) => {
        const options = {
            method: 'POST',
            url: API_URL.common.startAsynchronousExport,
            data: { type },
            dataType: 'json',
            doneResult: (res) => {
                const { success, asynchronousExportId } = res;
                message.success(success);
                const params = { ...searchArray, asynchronousExportId }
                ExportUtil.export(params, null, url);
            },
        };
        $.sendRequest(options);
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    getColumns = () => {
        const columns = [{
            title: '统计时间',
            dataIndex: 'yearMonth',
            key: 'yearMonth',
            fixed: 'left',
            width: 80,
        }, {
            title: '项目简称',
            dataIndex: 'investigationName',
            key: 'investigationName',
            fixed: 'left',
            width: 160,
        }, {
            title: '业务线',
            dataIndex: 'lineOfBusiness',
            key: 'lineOfBusiness',
            width: 80,
        }, {
            title: '执行业务线二级分类',
            dataIndex: 'secondLineName',
            key: 'secondLineName',
            width: 100,
        }, {
            title: 'JDE主项目号',
            dataIndex: 'mainCode',
            key: 'mainCode',
            width: 100,
        }, {
            title: '项目分类',
            dataIndex: 'investigationType',
            key: 'investigationType',
            width: 100,
        }, {
            title: '项目领域',
            dataIndex: 'investigationAreaName',
            key: 'investigationAreaName',
            width: 80,
        }, {
            title: '疾病',
            dataIndex: 'diseaseName',
            key: 'diseaseName',
            width: 80,
        }, {
            title: '领域leader',
            dataIndex: 'leaderNameCode',
            key: 'leaderNameCode',
            width: 100,
        }, {
            title: '项目分期',
            dataIndex: 'investigationByStageName',
            key: 'investigationByStageName',
            width: 80,
        }, {
            title: '区域',
            dataIndex: 'areaName',
            key: 'areaName',
            width: 90,
        }, {
            title: '省份',
            dataIndex: 'provinceName',
            key: 'provinceName',
            width: 80,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 90,
        }, {
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
            width: 120,
        }, {
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 90,
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 90,
        }, {
            title: '角色',
            dataIndex: 'roleCode',
            key: 'roleCode',
            width: 70,
        }, {
            title: '直线主管',
            dataIndex: 'leaderUser',
            key: 'leaderUser',
            width: 100,
        }, {
            title: '当月随机病例数',
            dataIndex: 'randomCount',
            key: 'randomCount',
            width: 105,
        }, {
            title: '当月完成访视数',
            dataIndex: 'visitNum',
            key: 'visitNum',
            width: 105,
        }, {
            title: '当月实时标准访视数',
            dataIndex: 'standardAmount',
            key: 'standardAmount',
            width: 80,
        }, {
            title: '当月确认标准访视数',
            dataIndex: 'confirmStandardAmount',
            key: 'confirmStandardAmount',
            width: 80,
        }, {
            title: '工作类型',
            dataIndex: 'enterpriseWorkNameValue',
            key: 'enterpriseWorkNameValue',
            width: 80,
        }, {
            title: '工作内容',
            dataIndex: 'enterpriseWorkTypeName',
            key: 'enterpriseWorkTypeName',
            width: 160,
        }, {
            title: '当月已确认FTE',
            dataIndex: 'fte',
            key: 'fte',
            width: 100,
        }];
        return columns;
    }
    
    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { exportable } = this.props;
        const { data, loading, pagination, searchParams, sortParams, businessList } = this.state;
        return (
            <div>
                <div className="reportTitle">{this.props.title}</div>
                <Filter
                    search={this.search}
                    params={searchParams}
                    businessList={businessList}
                    onChange={this.handleFilterChange}
                    buttons={[
                        exportable ?
                            <Button key="export" type="primary" onClick={this.showExportModal} style={{marginLeft: 8}}>导出</Button>
                        :
                            <Button key="export" disabled={true} style={{marginLeft: 8}}>导出</Button>
                    ]}
                />
                <div style={{marginTop: -20, marginBottom: 4, color: '#ffa500'}}>注：由于数据量过大，页面仅展示其中一个项目一个中心的数据，请导出后查看完整数据</div>
                <TableC
                    data={data}
                    scrollY={500}
                    loading={loading}
                    sortParams={sortParams}
                    columns={this.getColumns()}
                    className="randomInGroupVisit"
                    pagination={pagination}
                    onChange={this.handleTableChange}
                />
                <ExportSelectRangeModal key='1' ref={el => { this.exportSelectRangeRef = el; }} exportSelectRange = {this.export.bind(this)}/>
            </div>
        );
    }
}

export default RandomInGroupVisit;


// WEBPACK FOOTER //
// ./src/components/homePage/statement/randomInGroupVisit.js